/* eslint-disable arrow-body-style */

export function addModuloPaginaID(idModuloPagina) {
  return {
    type: 'ADD_MODULO_PAGINA_ID',
    idModuloPagina,
  };
}

export function addPaginaID(idPagina) {
  return {
    type: 'ADD_PAGINA_ID',
    idPagina,
  };
}
